export default __webpack_public_path__ + "static/media/loader.891053a9.svg";